import script from "./orderView.vue?vue&type=script&setup=true&lang=js"
export * from "./orderView.vue?vue&type=script&setup=true&lang=js"

import "./orderView.vue?vue&type=style&index=0&id=5988f7bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5988f7bb"]])

export default __exports__